import { OrganType } from '@/api/apis/case';

export const getOrganTypeLabel = (organ: OrganType, isScs: boolean) => {
  if (organ === OrganType.Lungs && isScs) return 'Lung';
  return organ;
};
